module.exports = __webpack_public_path__ + "media/images/ui__textArrowRightLight-cbb796b4a595a1b3af8df7b1ed88c3a3.png";